import { render, staticRenderFns } from "./EventConfParticipantsAprovation.vue?vue&type=template&id=19aa998c"
import script from "./EventConfParticipantsAprovation.vue?vue&type=script&lang=js"
export * from "./EventConfParticipantsAprovation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports